import './ChangeEmailForm.css';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import FormItem from '../FormItem/FormItem';
import Input from '../Input/Input';
import Button from '../Button/Button';
import MailIcon from '../../assets/Icons/MailIcon.svg?react';

import { Controller, useForm } from 'react-hook-form';
import { changeEmail } from '../../containers/UserProfilePage/actions';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { UserDto as User } from '@poker-stats/contracts';
import dayjs from 'dayjs';
import { getPokersiteNameByPokersiteId } from '../../containers/StatPage/utils';

const getSubscriptionLabel = (subsciption: number) => {
  switch (subsciption) {
    case 1:
      return '10-25';
    case 2:
      return '10-50';
    case 3:
      return '10-200';
    case 4:
      return 'Unlim';

    default:
      return '10-25';
  }
};

type Props = {
  user: User;
};

type FormValues = {
  email: string;
};

const ChangeEmailForm = ({ user }: Props) => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>({});

  const onSubmit = handleSubmit(({ email }) => {
    dispatch(changeEmail({ newEmail: email }));
  });
  return (
    <Flex className="ChangeEmailForm" vertical gap={0}>
      <Flex className="ChangeEmailForm__Title" align="center">
        <i className="ChangeEmailForm__TitleIcon">
          <MailIcon />
        </i>
        <Text size={4} bold>
          Email
        </Text>
      </Flex>

      <form className="ChangeEmailForm__Content" onSubmit={onSubmit}>
        <Flex showDivider gap={16}>
          <Flex vertical justify="space-around" gap={0}>
            <Text size={2} type="secondary">
              {t('current_email')}
            </Text>
            <Text size={3}>{user.email}</Text>
            {user.availablePokersiteIds &&
              user.availablePokersiteIds.length > 0 &&
              user.subscription &&
              user.subscriptionDate && (
                <Text size={3}>
                  {t('subscription')}:{' '}
                  <Text size={3} type="primary">
                    {getSubscriptionLabel(user.subscription)}
                  </Text>{' '}
                  {dayjs(user.subscriptionDate).locale('ru').format('DD MMMM YYYY')}{' '}
                  <Text size={3} type="primary">
                    {user.availablePokersiteIds
                      .map((x) => getPokersiteNameByPokersiteId(x))
                      .join(', ')}
                  </Text>
                </Text>
              )}
          </Flex>

          <FormItem error={errors.email?.message} className="ChangeEmailForm__Input">
            <Controller
              name="email"
              control={control}
              rules={{
                required: t('required'),
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: t('entered_value_does_not_match_email_format'),
                },
              }}
              render={({ field }) => (
                <Input
                  placeholder={t('new_email')}
                  autoComplete="off"
                  aria-invalid={errors.email?.message ? true : false}
                  {...field}
                />
              )}
            />
          </FormItem>
        </Flex>

        <FormItem className="ChangeEmailForm__Action">
          <Button>{t('change')}</Button>
        </FormItem>
      </form>
    </Flex>
  );
};

export default ChangeEmailForm;
